import { writable } from "svelte/store";

export interface IPart {
    name: string;
    href: string;
    active?: boolean;
}

export const navparts = writable<IPart[]>([]);